export enum DashboardCard {
  Clients = 'clients',
  NonCommissionableClients = 'nonCommissionableClients',
  Prospects = 'prospects',
  Policies = 'policies',
  Leads = 'leads',
}
